module.exports = __webpack_public_path__ + "img/arscp_logo_black.6831aad5.png";